import styled from 'styled-components';
import { FieldWrapper, Tag } from 'components';
import { lineHeight, theme, toRem } from 'design';

export const DaySegmentCard = styled.div`
  flex-direction: column;
  align-items: center;
  padding: ${toRem(theme.space.xl)};
  gap: ${toRem(theme.space.xl)};
  width: 100%;
  margin: ${toRem(theme.space.lg)} 0;
  background: ${theme.color.neutral[100]};
  border: ${toRem(1)} solid ${theme.color.neutral[200]};
  border-radius: ${toRem(8)};
`;

// Wraps once the day toggles and the time fields stop fitting side by side.
export const DaySegmentFieldRow = styled.div`
  flex-wrap: wrap;
  column-gap: ${toRem(theme.space.md)};
  width: 100%;

  > * {
    flex: 1 1 min-content;
  }

  > :first-child {
    flex-basis: max-content;
  }
`;

export const StyledFieldWrapper = styled(FieldWrapper)`
  label {
    font-size: ${toRem(theme.font.size.md)};
    line-height: ${lineHeight(theme.font.size.md)};
  }
`;

export const StyledTag = styled(Tag)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  text-align: center;
  white-space: pre-line;
  width: 100%;
  height: auto;
  padding: ${toRem(theme.space.lg)};
  color: ${theme.color.neutral[900]};
  font-size: ${toRem(theme.font.size.md)};
  font-weight: ${theme.font.weight.medium};
  line-height: ${lineHeight(theme.font.size.md)};
  text-transform: none;
`;

export const TimeFieldsWrapper = styled.div`
  column-gap: ${toRem(theme.space.md)};

  @media (max-width: ${theme.breakpoint.xsmall}px) {
    flex-wrap: wrap;
  }
`;
